import { SET_MODULE_ERRORS, CONTENT_SAVE_REQUEST_SUCCEEDED, FETCH_CONTENT_SCHEMA_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
// @ts-expect-error not yet migrated
import { convertObjectToCamelCase } from 'ContentEditorUI/utils/helpers';
import produce from 'immer';
const INITIAL_STATE = [];
const moduleErrorReducer = (state = INITIAL_STATE, action) => produce(state, draft => {
  const {
    type,
    payload,
    response
  } = action;
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        var _response$edit_errors, _response$edit_errors2;
        const moduleErrors = (_response$edit_errors = response === null || response === void 0 || (_response$edit_errors2 = response.edit_errors) === null || _response$edit_errors2 === void 0 ? void 0 : _response$edit_errors2.moduleErrors) !== null && _response$edit_errors !== void 0 ? _response$edit_errors : [];
        return moduleErrors;
      }
    case SET_MODULE_ERRORS:
      return response.errors.map(convertObjectToCamelCase);
    case CONTENT_SAVE_REQUEST_SUCCEEDED:
      {
        const {
          config: {
            setModuleErrorsAfterSave
          },
          response: {
            data: {
              errors = []
            }
          }
        } = payload;
        if (setModuleErrorsAfterSave) {
          return errors.map(convertObjectToCamelCase);
        }
        return draft;
      }
    default:
      return draft;
  }
});
export default moduleErrorReducer;